import { render, staticRenderFns } from "./FeedbacksTable.vue?vue&type=template&id=1dcac753&scoped=true"
import script from "./FeedbacksTable.vue?vue&type=script&lang=ts"
export * from "./FeedbacksTable.vue?vue&type=script&lang=ts"
import style0 from "./FeedbacksTable.vue?vue&type=style&index=0&id=1dcac753&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcac753",
  null
  
)

export default component.exports